import { filterEmptyObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/discover-places/reviews';

export default {
  async getDiscoverReviews(payload) {
    const response = await axiosClient.get(endPoint, {
      params: filterEmptyObject(payload),
    });
    return response.data;
  },

  async getDiscoverReviewDetails(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async deleteDiscoverReview(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.delete(path);
    return response.data;
  },
};
